/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import api from "../../../../services/api";
import {
    Button, Modal, Container, Row, Col, Input, FormGroup, Label
 } from "reactstrap"; 
import { ComboBox, DropdownBox } from "../../../dropdowns";
import { DatePicker } from "../../../date-pickers";
import Loader from "../../../loaders";
import moment from "moment";
import { formatDate, formatDateZeroTime } from "../../../../utils";
import { Stepper, Step, StepLabel } from '@material-ui/core';
import _ from 'lodash';
import { TooltipButton } from '../../../inputs';
import SweetAlert from 'react-bootstrap-sweetalert';

function JobOrderCandidateEditor(props) {
    const {
        jobOrder,
        setPdrsRequest,
        setMilestoneDocumentRequest
    } = props;

    const [ refresh, setRefresh ] = React.useState(null);
    const [ itemInEdit, setItemInEdit ] = React.useState(null);
    const [ itemHistory, setItemHistory] = React.useState([]);
    const [ currentCandidateMilestone, setCurrentCandidateMilestone ] = React.useState(null);
    const [ currentStep, setCurrentStep ] = React.useState(0);
    const [ milestones, setMilestones ] = React.useState([]);
    const [ milestoneAll, setMilestoneAll ] = React.useState([]);
    const [ loading, setLoading ] = React.useState(false);
    const [ confirmation, setConfirmation ] = useState(null);
    const [ validation, setValidation ] = useState(null);
    const [ uploadedMilestoneDocuments, setUploadedMilestoneDocuments ] = useState(null);
    const [ refreshCheckMilestone, setRefreshCheckMilestone ] = useState(null);
    const [ unpreferredCandidates, setUnpreferredCandidates ] = useState([]);
    const [ editedUnpreferredCandidates, setEditedUnpreferredCandidates ] = useState(null);

    React.useEffect(() => {
        if (props.jobOrderCandidateId > 0) {
            setLoading(true);
            setRefresh(null);

            let apiCalls = [
                api.get(`jobordercandidate/${props.jobOrderCandidateId}`), // 0
                api.get(`jobordercandidate/${props.jobOrderCandidateId}/mts`), // 1
                api.get(`jobordercandidate/${props.jobOrderCandidateId}/nmt`), // 2
                api.get(`jobordercandidate/${props.jobOrderCandidateId}/mth`), // 3
                api.get(`jobordercandidate/${props.jobOrderCandidateId}/mts-all`), // 4
            ];

            Promise.all(apiCalls)            
            .then((response) => {
                setItemInEdit(response[0].data);
                setMilestones(response[1].data);
                setCurrentCandidateMilestone({ jobOrderCandidateId: props.jobOrderCandidateId, pointOfHire: response[0].data?.pointOfHire, position: response[0].data?.position, milestoneDate: moment().format("YYYY-MM-DD") });
                setItemHistory(response[3].data);
                setMilestoneAll(response[4].data);

                var i = _.findIndex(
                    response[1].data,
                    (item) => item.jobOrderMilestoneId == response[2].data.jobOrderMilestoneId
                );
                setCurrentStep(i);
            })
            .catch((error) => console.error(error))
            .finally(() => setLoading(false));
        }
    }, [refresh]);

    useEffect(() => {
        if (!refreshCheckMilestone)
            return;

        checkMilestone(refreshCheckMilestone.isAlreadySentMessage, refreshCheckMilestone.isAlreadyUploadDocument, refreshCheckMilestone.isMultiCandidatesChecked);
        setRefreshCheckMilestone(null);
    }, [refreshCheckMilestone]);

    const handleSelectedMilestoneChanged = (item) => {
        setCurrentCandidateMilestone( { ...currentCandidateMilestone,
            jobOrderMilestoneId: item ? item.jobOrderMilestoneId : null,
            jobOrderMilestoneMasterId: item ? item.jobOrderMilestoneMasterId : null,
            milestoneName: item ? item.milestoneName : "",
            orderingIndex: item ? item.orderingIndex : null,
            requireSms: item ? item.requireSms : null,
            needDocument: item ? item.needDocument : null,
            defaultDocumentTypeId: item ? item.defaultDocumentTypeId : null,
            defaultDocumentType: item ? item.defaultDocumentType : null,
            canViewDocumentTemplate: item ? item.canViewDocumentTemplate : null,
        });
    };

    const handleTextChanged = ({ target: { name, value } }) => {
        setCurrentCandidateMilestone({ ...currentCandidateMilestone, [name]: value });
    }
    
    const handleDateChanged = (value, name) => {
        setCurrentCandidateMilestone({ 
            ...currentCandidateMilestone, 
            [name]: !value ? null : formatDateZeroTime(value) //moment(value).format("YYYY-MM-DDT00:00:00") 
        });
    }

    const handleSavePosition = useCallback(() => {
        setLoading(true);
        api.put(
            `jobordercandidate/${currentCandidateMilestone.jobOrderCandidateId}/position`,
             JSON.stringify({positionId: currentCandidateMilestone?.position?.positionId ?? null}))
        .then(() => {
            setItemInEdit({...itemInEdit, positionId: currentCandidateMilestone?.position?.positionId ?? null, position: currentCandidateMilestone?.position});
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            setLoading(false);
        });
    }, [currentCandidateMilestone, itemInEdit]);

    const handleSavePointOfHire = useCallback(() => {
        setLoading(true);
        api.put(
            `jobordercandidate/${currentCandidateMilestone.jobOrderCandidateId}/poh`,
             JSON.stringify({pointOfHire: currentCandidateMilestone?.pointOfHire ?? null}))
        .then(() => {
            setItemInEdit({...itemInEdit, pointOfHire: currentCandidateMilestone.pointOfHire});
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            setLoading(false);
        });
    }, [currentCandidateMilestone, itemInEdit]);

    const handleSave = useCallback((completed, updateRoster, callback) => {
        setLoading(true);
        api.post(
            `jobordercandidate/${currentCandidateMilestone.jobOrderCandidateId}/newmile?completed=${completed ?? "false"}&updateroster=${updateRoster ?? "false"}`,
                JSON.stringify(currentCandidateMilestone))
        .then((response) => {
            // props.onSaved(itemInEdit);

            if (!uploadedMilestoneDocuments?.length)
            {
                setLoading(false);
                setRefresh(true);
                
                if (callback)
                    callback();
                
                return;
            }

            const formData = new FormData();

            uploadedMilestoneDocuments.forEach((u, u_idx) => {
                formData.append(`[${u_idx}].jobOrderCandidateMilestoneId`, response.data.jobOrderCandidateMilestoneId);
                formData.append(`[${u_idx}].file`, u.file);

                if (currentCandidateMilestone?.defaultDocumentTypeId)
                    formData.append(`[${u_idx}].documentTypeId`, currentCandidateMilestone.defaultDocumentTypeId);
            });
            // formData.append(`jobOrderCandidateMilestoneIds[0]`, currentData);

            const url = `${process.env.REACT_APP_WEB_API_BASE_URI}/jobordercandidate/newmiledocument`;
            const method = "POST";
    
            api({
                url,
                method,
                data: formData,
            })
                .then(() => {
                    setLoading(false);
                    setRefresh(true);
                    
                    if (uploadedMilestoneDocuments)
                        setUploadedMilestoneDocuments(null);
                })
                .catch((error) => {
                    console.error({error});

                    if (uploadedMilestoneDocuments)
                        setUploadedMilestoneDocuments(null);
                    
                    setLoading(false);
                })
            ;
        })
        .catch((error) => {
            console.error({error});

            if (confirmation)
                setConfirmation(null);
            
            setValidation({
                title: "Submission Failed",
                message: error.response.status < 500 ? `${error.response.data}` : "System error. Please contact admin."
            });

            if (uploadedMilestoneDocuments)
                setUploadedMilestoneDocuments(null);

            setLoading(false);
        });
    }, [currentCandidateMilestone, uploadedMilestoneDocuments]);

    const checkMilestone = useCallback((isAlreadySentMessage = false, isAlreadyUploadDocument = false, isMultiCandidatesChecked = false) => {
        if (!currentCandidateMilestone?.milestoneName) {
            setValidation({
                title: `Job Order Candidate - ${itemInEdit?.candidate?.candidateName}`,
                message: "Please select the Milestone Progress Update from the list."
            });
            return;
        }

        if (!currentCandidateMilestone?.milestoneDate) {
            setValidation({
                title: `Job Order Candidate - ${itemInEdit?.candidate?.candidateName}`,
                message: "Please enter the Milestone Date."
            });
            return;
        }

        if (!isAlreadyUploadDocument && currentCandidateMilestone?.needDocument)
        {
            setMilestoneDocumentRequest({
                jobOrderCandidates: [{...itemInEdit, ...currentCandidateMilestone}],
                onSubmit: (submittedData) => {
                    if (submittedData?.files?.length)
                        setUploadedMilestoneDocuments(submittedData?.files);

                    setMilestoneDocumentRequest(null);
                    setRefreshCheckMilestone({
                        isAlreadySentMessage,
                        isAlreadyUploadDocument: submittedData?.files?.length > 0 ? true : false,
                        isMultiCandidatesChecked,
                    });
                },
                milestoneName: currentCandidateMilestone.milestoneName,
                documentType: currentCandidateMilestone?.defaultDocumentType,
                canViewDocumentTemplate: currentCandidateMilestone?.canViewDocumentTemplate,
            })
            return;
        }

        if (!isAlreadySentMessage && currentCandidateMilestone?.requireSms == true) {
            const name = currentCandidateMilestone?.milestoneName == null ? '' : currentCandidateMilestone?.milestoneName.trim();
            setLoading(true);

            api.get(`/messagesmaster/milestone/${currentCandidateMilestone.jobOrderMilestoneMasterId}`)
                .then((response) => {
                    if (!response.data) {
                        setLoading(false);
                        setValidation({
                            title: `Milestone Editor`,
                            message: `Milestone ${name} requires a message master template, which is not found, please open Maintenance -> Job Order Milestone Master -> Edit ${name} -> Pick a message template -> Save.`
                        });
                        return;
                    }

                    const candidate = {
                        ...itemInEdit?.candidate,
                        jobOrderCandidateId: itemInEdit?.jobOrderCandidateId,
                        jobOrderId: itemInEdit?.jobOrderId,
                    };
                    const newPdrsRequest = {
                        milestoneName: name,
                        jobOrderCandidateId: itemInEdit?.jobOrderCandidateId,
                        jobOrderId: itemInEdit?.jobOrderId,
                        projectId: itemInEdit?.jobOrder?.projectId,
                        candidateId: itemInEdit?.candidateId,
                        itemSMS: [candidate],
                        defaultMessage: response.data,
                        onSaved: (isSuccess = true) => {
                            setRefreshCheckMilestone({
                                isAlreadySentMessage: isSuccess,
                                isAlreadyUploadDocument,
                                isMultiCandidatesChecked,
                            });
                        }
                    };

                    setLoading(false);
                    setPdrsRequest(newPdrsRequest);
                })
                .catch((error) => {
                    setLoading(false);
                    setValidation({
                        title: `Job Order Candidate - ${itemInEdit?.candidate?.candidateName}`,
                        message: `Unexpected error.`
                    });
                    console.error(error);
                });

            return;
        }

        if (!milestones.length || !itemInEdit || !currentCandidateMilestone)
        {
            handleSave();
            return;
        }

        const latestMilestoneId = milestones[milestones.length - 1].jobOrderMilestoneId;
        const currentMilestone = milestones.filter(m => m.jobOrderMilestoneId == currentCandidateMilestone.jobOrderMilestoneId)[0];

        if (latestMilestoneId !== currentCandidateMilestone.jobOrderMilestoneId && !currentMilestone.isCompletionPoint)
        {
            handleSave();
            return;
        }

        if (!isMultiCandidatesChecked && itemInEdit?.isMultiCandidates)
        {
            setLoading(true);

            api.get(`/jobordercandidate/${itemInEdit.jobOrderCandidateId}/sub?unpreferred=true`)
                .then((response) => {
                    const unpreferredList = response.data;

                    if (!unpreferredList.length)
                    {
                        setCurrentCandidateMilestone({
                            ...currentCandidateMilestone,
                            slotComments: [],
                        });
                        setRefreshCheckMilestone({
                            isAlreadySentMessage,
                            isAlreadyUploadDocument,
                            isMultiCandidatesChecked: true,
                        });
                        setLoading(false);
                        return;
                    }

                    setUnpreferredCandidates(response.data);

                    if (!response.data?.length)
                        return;

                    const editedResult = response.data.reduce((acc, item) => {
                        acc[`joc_${item.jobOrderCandidateId}`] = item.candidateName;
                        acc[`joc_${item.jobOrderCandidateId}_comments`] = null;
                        return acc;
                    }, {});

                    setEditedUnpreferredCandidates({
                        editedResult,
                        isAlreadySentMessage,
                        isAlreadyUploadDocument,
                    });
                    setLoading(false);
                })
                .catch((error) => {
                    setValidation({
                        title: `Job Order Candidate - ${itemInEdit?.candidate?.candidateName}`,
                        message: `Unexpected error.`
                    });
                    console.error(error);
                    setLoading(false);
                });

            return;
        }

        if (!itemInEdit.jobOrder.rosterId)
        {
            if (!itemInEdit?.candidateResidencyValidated)
            {
                setValidation({
                    title: `Job Order Candidate - ${itemInEdit?.candidate?.candidateName}`,
                    message: `Please validate the talent's residency status.`
                });
                return;
            }
            
            handleSave(true);
            return;
        }

        setConfirmation({
            type: "Talent Placement",
            title: "Talent Placement",
            message: `Do you want to automatically assign the talent to Dispatch ${itemInEdit.jobOrder.dispatchUnitName}?`
        });
    }, [itemInEdit, milestones, currentCandidateMilestone, uploadedMilestoneDocuments, handleSave]);

    const handleOnConfirmed = useCallback(() => {
        if (!confirmation)
            return;

        if (confirmation.type === "Set to Filled")
        {
            if (!itemInEdit?.candidateResidencyValidated)
            {
                setValidation({
                    title: `Job Order Candidate - ${itemInEdit?.candidate?.candidateName}`,
                    message: `Please validate the talent's residency status.`
                });
                return;
            }
            
            handleSetToFilled(() => setConfirmation(null));
            return;
        }

        if (confirmation.type === "Talent Placement")
        {
            if (!itemInEdit?.candidateResidencyValidated)
            {
                setValidation({
                    title: `Job Order Candidate - ${itemInEdit?.candidate?.candidateName}`,
                    message: `Please validate the talent's residency status.`
                });
                return;
            }

            handleSave(true, true, () => setConfirmation(null));
            return;
        }
    }, [itemInEdit, confirmation]);

    const handleSetToFilled = useCallback((callback) => {
        setLoading(true);
        api.put(`jobordercandidate/${currentCandidateMilestone.jobOrderCandidateId}/filled`)
        .then(({data}) => {
            setItemInEdit({...itemInEdit, status: {...data.status}, statusId: data.statusId, filledBy: data.filledBy, filledDate: data.filledDate});
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            setLoading(false);

            if (callback)
                callback();
        });
    }, [currentCandidateMilestone, itemInEdit]);

    const renderHistoryList = (item, index) => {      
        return (
            <li key={index} className="list-group-item">
                {item.milestoneDate && moment(item.milestoneDate).format("ddd, DD.MM.YYYY") }{item.submittedBy ? ` - ${item.submittedBy}` : ""} <i className="fas fa-angle-right ml-1 mr-1"></i> {item.milestoneName}
                <br />
                <blockquote className="blockquote">
                    <p className="mb-0">{item.milestoneNote && item.milestoneNote.length > 0 ? item.milestoneNote : "No Comment."}</p>
                </blockquote>
            </li>
        );        
    }
    
    return (
        <>
            <Modal
                isOpen={true}
                className="modal-xl"
                modalClassName="db-example-modal-xl"
            >
            {
                confirmation ?
                <SweetAlert
                    title={confirmation.title}
                    warning
                    showCancel
                    cancelBtnText="No"
                    confirmBtnText="Yes"
                    confirmBtnBsStyle="danger"
                    onConfirm={() => handleOnConfirmed()}
                    onCancel={() => {
                        if (confirmation.type === "Set to Filled")
                        {
                            setConfirmation(null);
                            return;
                        }

                        if (confirmation.type === "Talent Placement")
                        {
                            if (!itemInEdit?.candidateResidencyValidated)
                            {
                                setConfirmation(null);
                                setValidation({
                                    title: `Job Order Candidate - ${itemInEdit?.candidate?.candidateName}`,
                                    message: `Please validate the talent's residency status.`
                                });
                                return;
                            }

                            handleSave(true, false, () => setConfirmation(null));
                            return;
                        }
                    }}
                >
                    {confirmation.message}
                </SweetAlert>
                :
                null
            }
            {
                validation ?
                <SweetAlert
                    title={validation.title}
                    error
                    confirmBtnText="OK"
                    confirmBtnBsStyle="danger"
                    onConfirm={() => setValidation(null)}
                >
                    {validation.message}
                </SweetAlert>
                :
                null
            }
                <div className="modal-header">
                    <h5 className="modal-title">Job Order Candidate - {itemInEdit?.candidate?.candidateName}</h5>
                    <button
                        aria-label="Close"
                        className="close"
                        onClick={props.onClose}
                        type="button"
                    >
                        <span aria-hidden={true}><i className="fas fa-times-circle" /></span>
                    </button>
                </div>
                <div className="modal-body milestone">
                    <Container fluid className="px-0">
                        {(loading) && <Loader />}
                        <Row>
                            <Col md={12}>
                                <Stepper alternativeLabel>
                                {
                                    milestoneAll.map((item, index) => {
                                        const completed = !!itemHistory.find(f => f.jobOrderMilestoneId == item.jobOrderMilestoneId);
                                        const isComplete = item.orderingIndex <= currentStep;
                                        return (
                                            <Step key={index} completed={completed} active={completed} className={isComplete ? 'milestone-complete' : ''}>
                                                <StepLabel>
                                                    <span style={item.isRequired ? {color: "#d32f2f"} : {}}>{item.milestoneName}</span>
                                                </StepLabel>
                                            </Step>
                                        );
                                    }
                                )}
                                </Stepper>
                            </Col>
                        {
                            !jobOrder?.isCancelled &&
                            <Col md={4} className="border-right border-black">
                                <FormGroup className="mb-3 pb-3 border-bottom-3">
                                    <Label>
                                        Employed Position
                                    </Label>
                                    <Container fluid>
                                        <Row>
                                            <Col lg={10} className="m-0 p-0">
                                                <ComboBox
                                                    minLength={0}
                                                    endpoint="/position/searchname"
                                                    isLookup={false}
                                                    idField="positionId"
                                                    valueField="positionName"
                                                    selectedItem={currentCandidateMilestone?.position}
                                                    onChange={(item) => {                                   
                                                        setCurrentCandidateMilestone( { ...currentCandidateMilestone, position: item } );
                                                    }}
                                                />
                                            </Col>
                                            <Col lg={2} className="m-0 p-0 d-flex flex-wrap justify-content-center align-items-center">
                                                <TooltipButton
                                                    id="save-poh"
                                                    title="Save Employed Position"
                                                    className="btn-icon"
                                                    color="info"
                                                    size="sm"
                                                    type="button"
                                                    onClick={() => handleSavePosition()}
                                                >
                                                    Save
                                                </TooltipButton>
                                            </Col>
                                        </Row>
                                    </Container>
                                </FormGroup>
                                <FormGroup className="mb-3 pb-3 border-bottom-3">
                                    <Label>
                                        Point of Hire
                                    </Label>
                                    <Container fluid>
                                        <Row>
                                            <Col lg={10} className="m-0 p-0">
                                                <Input
                                                    name="pointOfHire"
                                                    id="pointOfHire"
                                                    type="text"
                                                    placeholder="Point of Hire"
                                                    rows={8}
                                                    value={currentCandidateMilestone?.pointOfHire ?? ""}
                                                    onChange={handleTextChanged}
                                                />
                                            </Col>
                                            <Col lg={2} className="m-0 p-0 d-flex flex-wrap justify-content-center align-items-center">
                                                <TooltipButton
                                                    id="save-poh"
                                                    title="Save Point of Hire"
                                                    className="btn-icon"
                                                    color="info"
                                                    size="sm"
                                                    type="button"
                                                    onClick={() => handleSavePointOfHire()}
                                                >
                                                    Save
                                                </TooltipButton>
                                            </Col>
                                        </Row>
                                    </Container>
                                </FormGroup>
                                <FormGroup>
                                    <Label>
                                        Milestone Progress Update
                                    </Label>
                                    <DropdownBox 
                                        data={milestones}
                                        idField="jobOrderMilestoneId"
                                        valueField="milestoneName"
                                        selectedItem={currentCandidateMilestone}
                                        onChange={(item) => { 
                                            handleSelectedMilestoneChanged(item);
                                        }}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <DatePicker 
                                        name="milestoneDate"
                                        id="milestoneDate"
                                        type="text"
                                        required
                                        value={formatDate(currentCandidateMilestone == null ? "" : currentCandidateMilestone.milestoneDate)}
                                        onChange={handleDateChanged}
                                        closeOnSelect
                                        disabled={true}          
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Input
                                        name="milestoneNote"
                                        id="milestoneNote"
                                        type="textarea"
                                        placeholder="Milestone Note"
                                        rows={8}
                                        value={currentCandidateMilestone == null ? "" : currentCandidateMilestone.milestoneNote}
                                        onChange={handleTextChanged}
                                    />
                                </FormGroup>
                                <FormGroup className="mb-3 pb-3 border-bottom-3">
                                    <Button
                                        color="primary"
                                        onClick={() => {
                                            checkMilestone();
                                        }}
                                        type="button">
                                        Submit Progress <i className="fas fa-caret-right ml-2"></i>
                                    </Button>
                                </FormGroup>
                                {/* <FormGroup>
                                    <Label>
                                        Recruiter may at their discretion change the status of this job order slot to "Filled".
                                    </Label>
                                    <Container fluid>
                                        <Row className>
                                            <Col lg={12} className="m-0 p-0 d-flex flex-wrap justify-content-start align-items-start">
                                                <Button
                                                    color="primary"
                                                    onClick={() => {
                                                        setConfirmation({
                                                            type: "Set to Filled",
                                                            title: "Set to Filled Confirmation",
                                                            message: "Are you sure you want to update the status to Filled?",
                                                        });
                                                    }}
                                                    type="button"
                                                    disabled={itemInEdit?.status?.lookupValue === "Filled"}
                                                >
                                                    Set to Filled
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Container>
                                </FormGroup> */}
                            </Col>
                        }
                            <Col md={jobOrder?.isCancelled ? 12 : 8} className="border-left border-black">
                            {
                                (!loading) ?
                                itemHistory && itemHistory.length === 0 ? 
                                (
                                    <p className="text-center text-muted">No Progress / New Candidate</p>
                                ) : itemHistory && itemHistory.length > 0 ?
                                (
                                    <>
                                        <ul className="list-group list-group-flush" style={{overflowY: 'auto', height: 'calc(100vh - 100px)'}}>
                                            {itemHistory.map(renderHistoryList)}
                                        </ul>
                                    </>
                                ) : null
                                : null  
                            }
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div
                    className="modal-footer"
                >
                    <Button
                        color="secondary"
                        onClick={() => {
                            props.onClose(itemInEdit)
                        }}
                        type="button"
                    >
                        Close
                    </Button>
                </div>
            </Modal>
        {
            editedUnpreferredCandidates && unpreferredCandidates?.length ?
            <Modal
                isOpen={true}
                className="modal-lg"
                modalClassName="db-example-modal-lg"
            >
                <div className="modal-header">
                    <h5 className="modal-title">Job Order Slot #{itemInEdit?.slotNumber} - Unpreferred Candidates Comments</h5>
                    <button
                        aria-label="Close"
                        className="close"
                        onClick={() => {
                            setEditedUnpreferredCandidates([]);
                            setUnpreferredCandidates([]);
                            setRefreshCheckMilestone(null);
                        }}
                        type="button"
                    >
                        <span aria-hidden={true}><i className="fas fa-times-circle" /></span>
                    </button>
                </div>
                <div className="modal-body milestone">
                    <Container fluid className="px-0">
                        {(loading) && <Loader />}
                        <Row className="w-100 m-0 p-0">
                        {
                            unpreferredCandidates.map((u, u_idx) => {
                                return (
                                    <Col className="m-0 p-0" key={`unpreferred_${u_idx}`} md={12}>
                                        <FormGroup>
                                            <Label>{u.candidateName}</Label>
                                            <Input
                                                type="textarea"
                                                value={editedUnpreferredCandidates[`joc_${u.jobOrderCandidateId}_comments`] ?? ""}
                                                id={`joc_${u.jobOrderCandidateId}_comments`}
                                                name={`joc_${u.jobOrderCandidateId}_comments`}
                                                onChange={({ target: { name, value } }) => {
                                                    setEditedUnpreferredCandidates({...editedUnpreferredCandidates, [name]: value});
                                                }}
                                                rows={3}
                                            />
                                        </FormGroup>
                                    </Col>
                                )
                            })
                        }
                        </Row>
                    </Container>
                </div>
                <div
                    className="modal-footer"
                >
                    <Button
                        color="secondary"
                        onClick={() => {
                            setEditedUnpreferredCandidates(null);
                            setUnpreferredCandidates([]);
                            setRefreshCheckMilestone(null);
                        }}
                        type="button"
                    >
                        Close
                    </Button>
                    <Button
                        color="default"
                        onClick={() => {
                            const newUnpreferredCandidates = unpreferredCandidates.map(u => {
                                return {
                                    jobOrderCandidateId: u.jobOrderCandidateId,
                                    comments: editedUnpreferredCandidates[`joc_${u.jobOrderCandidateId}_comments`],
                                };
                            });
                            
                            setCurrentCandidateMilestone({
                                ...currentCandidateMilestone,
                                slotComments: newUnpreferredCandidates,
                            })
                            setRefreshCheckMilestone({
                                isAlreadySentMessage: editedUnpreferredCandidates.isAlreadySentMessage,
                                isAlreadyUploadDocument: editedUnpreferredCandidates.isAlreadyUploadDocument,
                                isMultiCandidatesChecked: true,
                            });
                            setEditedUnpreferredCandidates(null);
                            setUnpreferredCandidates([]);
                        }}
                        type="button"
                    >
                        Save
                    </Button>
                </div>
            </Modal>
            :
            null
        }
        </>
    )
}

export default JobOrderCandidateEditor;